import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ObjectToQueryParam } from "../utils";

export const fetchExpenseVendors = createAsyncThunk("expenseVendors", async ({ filter }: { filter?: { page?: number, count?: number, search?: string } }, { getState }) => {
  let queryParams = '';
  if (filter) {
    queryParams = ObjectToQueryParam(filter);
  }
  
  return axios.get(`/expense-vendors?${queryParams}`).then((res) => ({ response: res.data, queryParams }));
});

export const createExpenseVendors = async (id: string, name: string): Promise<{ success: boolean }> => {
  const body = {
    SL_Vendor_ID__c: id,
    Name: name
  };
  return axios.post(`/expense-vendors`, body).then((res) => res.data);
};

// Then, handle actions in your reducers:
const expenseVendorsSlice = createSlice({
  name: "expenseVendors",
  initialState: {
    loading: false,
    totalCount: 0,
    queryParams: "",
    data: [] as ExpenseVendor[],
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchExpenseVendors.fulfilled.type]: (state, action) => {
      const data = action.payload.response.data;
      state.data = data;
      state.totalCount = action.payload.response.totalCount;
      state.queryParams = action.payload.queryParams;
      state.loading = false;
    },
    [fetchExpenseVendors.pending.type]: (state, action) => {
      state.loading = true;
    },
    [fetchExpenseVendors.rejected.type]: (state, action) => {
      state.loading = false;
    },
  },
});

export default expenseVendorsSlice.reducer;

export interface ExpenseVendor {
    sL_Vendor_ID__c: string;
    name: string;
}
